import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginTop: '8px',
  },
  input: {
    '& div>input': {
      textAlign: 'center',
      fontSize: theme.typography.h6.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      '&::placeholder': {
        textAlign: 'center',
      },
    }
  }
}));
